mutation AssignTrainingModule(
  $moduleId: ID!
  $employeeIds: [ID!]
  $dueOn: ISO8601Date
) {
  assignTrainingModule(
    input: { moduleId: $moduleId, employeeIds: $employeeIds, dueOn: $dueOn }
  ) {
    assignedCount
  }
}
